import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_URL}/api/ntt`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("tokenInv");
  return {
    Authorization: `Bearer ${token}`,
    "ngrok-skip-browser-warning": "true",
  };
};

export const fetchSowDashboard = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/dashboard/overview`, {
      headers: getAuthHeaders(),
    });
    return response?.data?.data; 
  } catch (err) {
    console.error("Error in fetching data:", err);
    throw err;
  }
};

export const fetchAllSow = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/sow`, {
      headers: getAuthHeaders(),
    });
    return response.data; 
  } catch (err) {
    console.error("Error in fetchAllSow:", err);
    throw err;
  }
};

export const fetchSowById = async (sowId) => {
  try {
    const response = await axios.get(`${BASE_URL}/sow/${sowId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (err) {
    console.error("Error in fetchSowById:", err);
    throw err;
  }
};

export const extractSow = async (sowId) => {
  try {
    const response = await axios.get(`${BASE_URL}/sow/${sowId}/extract`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (err) {
    console.error("Error in extractSow:", err);
    throw err;
  }
};


export const uploadSow = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(`${BASE_URL}/upload_sow`, formData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (err) {
    console.error("Error in uploadSow:", err);
    throw err;
  }
};

